import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { PushPin } from '@bibliocommons/deprecated-base-icons';
import SearchBar from '@bibliocommons/search-bar';

import './CatalogueSearchBar.scss';

export default class CatalogueSearchBar extends React.PureComponent {
  render() {
    return (
      <div className={cn('cp-catalogue-search-bar', { locked: this.props.locked })}>
        {this.props.locked && <PushPin className="locked-icon" />}
        <SearchBar
          query={this.props.query}
          handleSearch={this.props.handleSearch}
          handleChange={this.props.handleChange}
          isWrappedInForm={false}
        />
      </div>
    );
  }
}

CatalogueSearchBar.propTypes = {
  query: PropTypes.string,
  locked: PropTypes.bool,
  handleSearch: PropTypes.func,
  handleChange: PropTypes.func
};
